'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';
import { UnauthQueryOptions } from '@/api';
const TREND_SIZE = 20;
const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;
const trendQueryOptions = UnauthQueryOptions['get:/wello/v2/allows/trend'];
export type TrendKeywordItem = NonNullable<NonNullable<Awaited<ReturnType<NonNullable<ReturnType<typeof trendQueryOptions>['queryFn']>>>['context']>['contents']>[number];
export const useTrendKeywords = t0 => {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = trendQueryOptions({
      query: {
        size: TREND_SIZE
      }
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== enabled) {
    t4 = {
      ...t3,
      enabled,
      select: _temp
    };
    $[3] = enabled;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    data: t5,
    isPending
  } = useQuery(t4);
  let t6;
  if ($[5] !== t5) {
    t6 = t5 === undefined ? [] : t5;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const keywords = t6;
  const isHydrated = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
  if (!isHydrated) {
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        keywords: [],
        isPending: true
      };
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    return t7;
  }
  let t7;
  if ($[8] !== isPending || $[9] !== keywords) {
    t7 = {
      keywords,
      isPending
    };
    $[8] = isPending;
    $[9] = keywords;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
function _temp(data) {
  return data.context?.contents ?? [];
}